import React from "react";
import TestFile from "./files/TestFile";
import MumbaiToPune from "./files/MumbaiToPune";
import LeanVsScale from "./files/LeanVsScale";

//Category
/*
Categories:-
    travel
    business

Type:-
    info
    opinion

Position:-
    latest

{
id:
publish:
position:
file:
title:
pageName:
author:
category:
type:
date:
featureImage:
}
 */
const Repository = [
    
    {
        uid: "123",
        publish:false,
        position: "a",
        file: <TestFile/>,
        title: "Testing first",
        pageName:"Testing first",
        author: "Hartaj",
        category: "a",
        type: "Opinion",
        publishedDate:"1 Oct 2024"
    },
    
    {
        uid: "456",
        publish:false,
        position: "latest",
        //file: "file",
        title: "Testing second",
        pageName:"Testing second",
        author: "Singh",
        category: "b",
        type: "Analysis",
        publishedDate:"02/10/2024"
    },
    
    {
        uid: "20241005",
        publish:false,
        position: "latest",
        file: <LeanVsScale/>,
        title: "Lean vs Scale: Which path will lead to success?",
        pageName:"Lean vs To-Scale Start Ups",
        author: "Hartaj S Trehan",
        category: "business",
        type: "opinion",
        publishedDate:"05/10/2024"
    },

    {
        uid: "20241002",
        publish:false,
        position: "latest",
        file: <MumbaiToPune/>,
        title: "Travel Mumbai to Pune",
        pageName:"Mumbai to Pune",
        author: "Hartaj S Trehan",
        category: "travel",
        type: "info",
        publishedDate:"02/10/2024"
    }
]

export default Repository